import { createTheme, type PaletteMode } from "@mui/material";

export function buildTheme(mode: PaletteMode) {
  return createTheme({
    palette: {
      mode,
      ...(mode === "dark"
        ? {
            primary: { main: "#22c55e" },
            secondary: { main: "#8b5cf6" },
            error: { main: "#ef4444" },
            warning: { main: "#f59e0b" },
            success: { main: "#22c55e" },
            background: { default: "#0a0f1a", paper: "#1f2937" },
          }
        : {
            primary: { main: "#16a34a" },
            secondary: { main: "#7c3aed" },
            error: { main: "#dc2626" },
            warning: { main: "#d97706" },
            success: { main: "#16a34a" },
            background: { default: "#f8fafc", paper: "#ffffff" },
          }),
    },
    typography: {
      fontFamily: "'Inter', sans-serif",
    },
    shape: { borderRadius: 16 },
    components: {
      MuiButton: {
        styleOverrides: {
          root: {
            textTransform: "none",
            borderRadius: 9999,
            fontWeight: 500,
          },
        },
        defaultProps: { disableElevation: true },
      },
      MuiCard: {
        styleOverrides: {
          root: {
            borderRadius: 16,
            border: "1px solid",
            borderColor:
              mode === "dark" ? "rgba(255,255,255,0.08)" : "rgba(0,0,0,0.08)",
            ...(mode === "dark"
              ? {
                  background: "rgba(31, 41, 55, 0.6)",
                  backdropFilter: "blur(12px)",
                }
              : {}),
          },
        },
      },
      MuiListItemButton: {
        styleOverrides: {
          root: {
            borderRadius: 9999,
            "&.Mui-selected": {
              backgroundColor:
                mode === "dark"
                  ? "rgba(34,197,94,0.15)"
                  : "rgba(22,163,74,0.1)",
              color: mode === "dark" ? "#22c55e" : "#16a34a",
              "&:hover": {
                backgroundColor:
                  mode === "dark"
                    ? "rgba(34,197,94,0.25)"
                    : "rgba(22,163,74,0.15)",
              },
            },
          },
        },
      },
    },
  });
}
